import { UiSchema } from '@rjsf/utils';
import { isArray } from 'lodash/fp';
import { useCallback, VFC } from 'react';

import { ChangeValue } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateVisualVersionDiff/types';
import { ValueDiffLabel } from 'dashboard/apps/InquiryTemplateEditor/ValueDiffLabel';
import { PropertyRow } from 'dashboard/apps/InquiryTemplateEditor/VersionDiffTable';
import { UsableObjectConfig } from 'dashboard/lib/workflows';
import { WorkflowActionFromConfig } from 'dashboard/models/workflow-version';

interface WorkflowActionDiffObjectProps {
  actionParameters: WorkflowActionFromConfig['params'];
  schema: UiSchema;
  schemaKey: string;
  usableObjects: UsableObjectConfig[];
  parameterDiff: ChangeValue | null;
}

const WorkflowActionDiffObject: VFC<WorkflowActionDiffObjectProps> = ({
  actionParameters,
  schema,
  schemaKey,
  usableObjects,
  parameterDiff,
}) => {
  const getObjectLabel = useCallback(
    (parameterKey: string) =>
      usableObjects.find((object) => object.value === parameterKey)?.label ??
      schema['ui:placeholder'] ??
      'None',
    [schema, usableObjects],
  );

  const getLabel = (
    parameter: WorkflowActionFromConfig['params'][keyof WorkflowActionFromConfig['params']],
  ) => {
    if (parameter != null && isArray(parameter)) {
      return parameter.map((key) => getObjectLabel(key)).join(', ');
    } else {
      return getObjectLabel(parameter as string);
    }
  };

  return (
    <>
      <PropertyRow
        textKey={schema['ui:title']!}
        value={
          parameterDiff ? (
            <ValueDiffLabel
              valueDiff={{
                added: getLabel(parameterDiff.value),
                removed: getLabel(parameterDiff['prev-value']),
              }}
              fallbackValue='None'
              vertical
            />
          ) : (
            getLabel(actionParameters[schemaKey])
          )
        }
      />
    </>
  );
};

export default WorkflowActionDiffObject;
